import axios from 'axios';

export function updateUserRevenueShare(token, payload) {
    return axios.put(`${process.env.REACT_APP_API_URL}/admin/updateUserRevenueShare`, payload, {
        headers: { Authorization: token },
    });
}
